import styled from 'styled-components';
import { MenuItem } from '@mui/material';
import { theme } from '../../styles/theme';
export const Wrapper = styled(MenuItem) `
  && {
    padding: ${theme.spacing.sm} ${theme.spacing.md};

    &:hover {
      background: ${theme.colors.backgroundBrandLightest};
    }
  }
`;
export const Icon = styled.div `
  height: 24px;
  width: 24px;
  margin-right: ${theme.spacing.md};
`;
export const Text = styled.span `
  ${theme.typography.bodyLG};
`;
